import { apiGet } from './apiClient.js';
import { createCapabilityLoader } from './capabilityLoader.js';

const loader = createCapabilityLoader(apiGet);
export const getAdminMe = loader.get;
export const clearCapabilityCache = loader.clear;
